import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ICON } from '@core/util/icon';

export interface DocumentDeleteDialogData {
	documentName: string;
}

@Component({
	selector: 'app-uploaded-delete-modal',
	templateUrl: './delete-modal.component.html',
	standalone: false,
})
export class UploadedDeleteModalComponent {
	public documentName: string;
	public ICON = ICON;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DocumentDeleteDialogData,
		private dialogRef: MatDialogRef<UploadedDeleteModalComponent>,
	) {
		this.documentName = data.documentName;
	}

	cancelModal(): void {
		this.dialogRef.close(false);
	}

	deleteDocument(): void {
		this.dialogRef.close(true);
	}
}
